"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectibleSDKFactory = void 0;
var CollectibleSDK_1 = require("./CollectibleSDK");
var utils_1 = require("./lib/utils");
var CollectibleSDKFactory = /** @class */ (function () {
    function CollectibleSDKFactory() {
    }
    // Multiple SDKs referencing the same address should use the exact same instance
    CollectibleSDKFactory.getOrCreateInstance = function (params) {
        var collectibleAddress = params.collectibleAddress, collectibleInstanceId = params.collectibleInstanceId;
        var collectibleId = (0, utils_1.formatCollectibleId)(collectibleAddress, collectibleInstanceId);
        if (this.instances.has(collectibleId)) {
            return this.instances.get(collectibleId);
        }
        var collectibleSDK = new CollectibleSDK_1.CollectibleSDK(params);
        this.instances.set(collectibleId, collectibleSDK);
        return collectibleSDK;
    };
    CollectibleSDKFactory.getInstance = function (params) {
        var collectibleId;
        if (typeof params === 'string') {
            collectibleId = params;
        }
        else {
            collectibleId = (0, utils_1.formatCollectibleId)(params.collectibleAddress, params.collectibleInstanceId);
        }
        return this.instances.get(collectibleId.toLowerCase());
    };
    CollectibleSDKFactory.instances = new Map();
    return CollectibleSDKFactory;
}());
exports.CollectibleSDKFactory = CollectibleSDKFactory;
